import React from "react";
import SvgColor from "react-svg-color";
import theme from "../theme/theme";

interface Props{
  svg: any;
  color?: string; 
  width?: number;
}

function SvgContainer({ svg, color = theme.colors.primary, width=20 }:Props) {
  return <SvgColor svg={svg} width={width} colors={[color,color,color,color,color]} />;
}

export default SvgContainer;
